import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=7656cf6e&"
import script from "./BulkUpload.vue?vue&type=script&lang=js&"
export * from "./BulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports